// import browser from '@/util/browser'

export default [{
  path: '/event/referrer49',
  component: () => import('../views/page/event/referrer49.vue')
}, {
  path: '/event/referrer49/invent_list',
  component: () => import('../views/page/event/referrer49/invent_list.vue')
}]
